export const ScrollingService = {
   
   scrollToElement(elementId: string) {
      const element = document.getElementById(elementId);
      const topPosition = Math.round(element?.getBoundingClientRect().top as number)
      const targetPosition = topPosition - 100;

      window.scrollTo(0, window.scrollY + targetPosition); 
   }
}